import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { Form } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Popup from 'components/common/popup/popup';
import SoftwareUpdateHelper from 'components/navigation/softwareUpdate/softwareUpdateHelper';

const styles = {
  clearButton: {
    float: 'right',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: 0,
    paddingBottom: 0
  }
};

export default function SoftwareUpdateFilter(props) {
  const [creationGreaterThan, setCreationGreaterThan] = useState(props.filters && props.filters.creationGreaterThan ? props.filters.creationGreaterThan : '');
  const [creationLesserThan, setCreationLesserThan] = useState(props.filters && props.filters.creationLesserThan ? props.filters.creationLesserThan : '');
  const [creationFilter, setCreationFilter] = useState(props.filters && props.filters.creationFilter ? props.filters.creationFilter : '');
  const [softwareType, setSoftwareType] = useState(props.filters && props.filters.softwareType ? props.filters.softwareType : '');
  const [updateStatus, setUpdateStatus] = useState(props.filters && props.filters.updateStatus ? props.filters.updateStatus : '');

  const [softwareTypes, setSoftwareTypes] = useState([]);
  const [softwareUpdateStatuses, setSoftwareUpdateStatuses] = useState([]);

  useAsyncEffect(async () => {
    setSoftwareTypes(await SoftwareUpdateHelper.getSoftwareTypes());
    setSoftwareUpdateStatuses(await SoftwareUpdateHelper.getSoftwareUpdateStatuses());
  }, []);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    if (props.onChange) {
      props.onChange({ creationFilter, softwareType, updateStatus, creationGreaterThan, creationLesserThan });
    }
  };

  const renderClearButton = (states, setStates, label = 'Clear') => {
    var show = false;
    for (var i = 0; i < states.length; i++) {
      if (states[i] !== null && states[i].length > 0) {
        show = true;
      }
    }

    if (!show) {
      return null;
    }

    const clearStates = () => {
      for (var i = 0; i < states.length; i++) {
        setStates[i]('');
      }
    };

    return <Inputs.Button variant='hover-default' onClick={clearStates} style={styles.clearButton} label={label} />;
  };

  const renderCustomRange = () => {
    if (creationFilter !== 'customrange') return null;
    return (
      <>
        <Form.Group>
          <Form.Label>From:</Form.Label>
          <Inputs.Date value={creationGreaterThan} onChange={setCreationGreaterThan} />
        </Form.Group>
        <Form.Group>
          <Form.Label>To:</Form.Label>
          <Inputs.Date value={creationLesserThan} onChange={setCreationLesserThan} />
        </Form.Group>
      </>
    );
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  if (!props.show) {
    return null;
  }

  return (
    <Popup
      title='Select Filters'
      footer={renderFooter()}
      show={true}
      onClose={handleClose}
    >
      <Form>
        <Form.Group>
          <Form.Label>Creation Date</Form.Label>
          {renderClearButton([creationFilter], [setCreationFilter], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={creationFilter} onValueChange={setCreationFilter}>
            <Inputs.Option value='today' label='Today' />
            <Inputs.Option value='yesterday' label='Yesterday' />
            <Inputs.Option value='lastweek' label='Last 7 days' />
            <Inputs.Option value='previousweek' label='Previous 7 days' />
            <Inputs.Option value='recentpackage' label='Most recent package' />
            <Inputs.Option value='recent10packages' label='Most recent 10 packages' />
            <Inputs.Option value='recent20packages' label='Most recent 20 packages' />
            <Inputs.Option value='customrange' label='Custom Range' />
          </Inputs.Select>
        </Form.Group>

        {renderCustomRange()}

        <Form.Group>
          <Form.Label>Software Type</Form.Label>
          {renderClearButton([softwareType], [setSoftwareType], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={softwareType} onValueChange={setSoftwareType}>
            {softwareTypes && softwareTypes.map((type) => <Inputs.Option value={type.id} label={type.name} key={type.id} />)}
          </Inputs.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label>Status</Form.Label>
          {renderClearButton([updateStatus], [setUpdateStatus], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={updateStatus} onValueChange={setUpdateStatus}>
            {softwareUpdateStatuses && softwareUpdateStatuses.map((status) => (
              <Inputs.Option value={status.id} label={status.statusName} key={status.id} />
            ))}
          </Inputs.Select>
        </Form.Group>

        {renderClearButton([creationFilter, softwareType, updateStatus], [setCreationFilter, setSoftwareType, setUpdateStatus], 'Clear All')}
        <div style={{ clear: 'both' }}></div>
      </Form>
    </Popup>
  );
}